// extracted by mini-css-extract-plugin
export default {"detailsText":"LogsTableDetailsModal-detailsText-qjU64 Scroller-scroller-lhubq"};